import { MessageAPI } from "../../api/api";


const postMessage = (message) => async () => {
    await MessageAPI.postMessage(message)
}

export default postMessage;
